/** Shared copy for phone OTP (SMS and/or voice via 2factor). */

export { maskPhone } from "./phone";

export const PHONE_OTP_WHY_NOTE =
  "We confirm your phone so recruiters can reach you about real opportunities, and to prevent fake or duplicate registrations. Your number is only shared with the recruiter whose link you used — not listed publicly on AxioHire.";

export const PHONE_OTP_DELIVERY_NOTE =
  "You may receive the code by SMS or an automated phone call. Enter the 6-digit code either way.";

export function phoneOtpSentMessage(phoneMasked?: string): string {
  if (phoneMasked) {
    return `Code sent to ${phoneMasked}. You may receive it by SMS or an automated call.`;
  }
  return "Code sent. You may receive it by SMS or an automated call.";
}
